<div class="agreement-details-tab">
  <div class="details-container">
    <!-- Worker Agreement Details -->
    @if (isWorkerAgreement) {
      <app-worker-agreement-details-shared [agreement]="workerAgreement"> </app-worker-agreement-details-shared>
    }

    <!-- Employment Agreement Details -->
    @if (isEmploymentAgreement) {
      <app-employment-agreement-details-shared [agreement]="employmentAgreement">
      </app-employment-agreement-details-shared>
    }
  </div>
</div>
